module.exports = __webpack_public_path__ + "static/img/meibo.af871f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Main/SubSection/meibo.png
// module id = 44l2
// module chunks = 1